import SchedulerDataGrid from './scheduler-data-grid/scheduler-data-grid.component';
import {
  SchedulerContext,
  SchedulerContextType,
} from './scheduler-field.context';
import SchedulerToolbarForm from './scheduler-toolbar-form/scheduler-toolbar-form.component';

type SchedulerFieldProps = {
  value: SchedulerContextType;
};

export const SchedulerField = ({ value }: SchedulerFieldProps) => {
  return (
    <SchedulerContext.Provider value={value}>
      <SchedulerToolbarForm />
      <SchedulerDataGrid />
    </SchedulerContext.Provider>
  );
};

export default SchedulerField;
